exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nform[data-v-5942ab8f] {\n    width: 100%;\n}\n.btn-save[data-v-5942ab8f] {\n    float: right;\n    margin-top: 2px;\n}\n.btn-cancel[data-v-5942ab8f] {\n    margin-top: -10px;\n}\nh1[data-v-5942ab8f] {\n    display: inline-block;\n    margin-bottom: 18px;\n    margin-left: 10px;\n}\n", ""]);

// exports
